import { View } from './view'

export const PartnerFormSection = View
